import { PdfUploadedTable } from './PdfUploadedTable';
export default PdfUploadedTable;
